import { useTranslation } from "react-i18next";
import { Linkedin } from "lucide-react";
import type { LinkedinPresets as LinkedinPresetsData } from "@shared/schema";
import { PresetSection, PresetToggle } from "./PresetSection";

export function LinkedinPresets({
  value,
  onChange,
}: {
  value: LinkedinPresetsData;
  onChange: (next: LinkedinPresetsData) => void;
}) {
  const { t } = useTranslation();
  return (
    <PresetSection
      icon={<Linkedin size={14} style={{ color: "#0A66C2" }} />}
      title={t("contentScheduler.presets.linkedin.title")}
    >
      <PresetToggle
        label={t("contentScheduler.presets.linkedin.showLinkPreview")}
        description={t("contentScheduler.presets.linkedin.showLinkPreviewHint")}
        checked={value.showLinkPreview}
        onChange={(next) => onChange({ ...value, showLinkPreview: next })}
      />
      <PresetToggle
        label={t("contentScheduler.presets.linkedin.imageCarousel")}
        description={t("contentScheduler.presets.linkedin.imageCarouselHint")}
        checked={value.imageCarousel}
        onChange={(next) => onChange({ ...value, imageCarousel: next })}
      />
    </PresetSection>
  );
}
